import React, { useState } from "react";
import { HotelGuestDetailsForm } from "./HotelGuestDetailsForm";
import { HotelDetailsCard } from "./HotelDetailsCard";
import { HotelContactDetailsForm } from "./HotelContactDetailsForm";
import { Payment } from "../../../excursion/checkout/components/Payment";
import { HotelCheckoutTabs } from "../HotelCheckoutConstants";
import {
  HotelCheckoutGeneralTerms,
  HotelPolicies,
} from "../../details/components/HotelPolicies";

const BtnSpinner = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" style={{ display: "block", margin: "0 auto", width: "20px", height: "20px" }}>
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="42 60">
      <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite" />
    </circle>
  </svg>
);

export const HotelDetailsTabContent = ({
  details,
  values,
  errors,
  touched,
  setFieldValue,
  currentTab,
  hideHotelCard,
  onContinue,
  onlinePaymentEnable,
  acceptTerms,
  setAcceptTerms,
  download,
  downloading,
}) => {
  const [dlType, setDlType] = useState(null);
  let _values = values;
  if (
    details?.apiRequestConfirmation &&
    currentTab === HotelCheckoutTabs.CONFIRM
  ) {
    _values = {
      roomInfoValues: details?.apiRequestConfirmation?.roomInfo?.map((room) => {
        return {
          adults: room?.paxInfo
            ?.filter((p) => !p?.isChild)
            ?.map((p) => {
              return {
                ...p,
                type: "adults",
              };
            }),
          childs: room?.paxInfo
            ?.filter((p) => p?.isChild)
            ?.map((p) => {
              return {
                ...p,
                type: "childs",
              };
            }),
        };
      }),
      contactDetails: details?.apiRequestConfirmation?.contactDetails ?? {},
    };
  }

  const remarks = details?.apiResponse?.policies;
  const preview =
    currentTab === HotelCheckoutTabs.REVIEW ||
    currentTab === HotelCheckoutTabs.CONFIRM;
  return (
    <div className="hw-passenger--listShow">
      {hideHotelCard ? null : <HotelDetailsCard details={details} />}
      <div className="hw-hotel--guestCard">
        <HotelGuestDetailsForm
          key={`guest-${currentTab}`}
          details={details}
          values={_values}
          errors={errors}
          touched={touched}
          setFieldValue={setFieldValue}
          preview={preview}
          collapsible={preview}
          defaultOpen={currentTab === HotelCheckoutTabs.CONFIRM}
        />
        <HotelContactDetailsForm
          key={`contact-${currentTab}`}
          details={details}
          values={_values}
          errors={errors}
          touched={touched}
          setFieldValue={setFieldValue}
          preview={preview}
          collapsible={preview}
          defaultOpen={currentTab === HotelCheckoutTabs.CONFIRM}
        />

        {currentTab === HotelCheckoutTabs.CONFIRM ? (
          <>
            {/* <div className="hw-hotel--guestDivider" /> */}
            <div className="hw-fbk--ticketsSection hw-hotel--dlSticky hw-hotel--dlInline mt-16">
              <div className="hw-exchk--panelSubTitle">Download Tickets</div>
              <div className="hw-tk--dlRow">
                <div>
                  <button
                    type="button"
                    disabled={downloading}
                    onClick={() => {
                      setDlType("with");
                      const name = `${details?.apiRequestConfirmation?.roomInfo?.[0]?.paxInfo?.[0]?.firstName}_${details?.apiRequestConfirmation?.roomInfo?.[0]?.paxInfo?.[0]?.lastName}`;
                      download(
                        "/hotels/booking-details-pdf",
                        { _id: details?._id, withoutFare: false },
                        `hotel-booking-${name}-${details?.bookingReference || details?.apiResponseConfirmation?.APIRefNo || details?._id}`
                      );
                    }}
                    className="hw-btn hw-btn--primary" style={{ minWidth: "130px" }}
                  >
                    {downloading && dlType === "with" ? <BtnSpinner /> : "With Fare"}
                  </button>
                </div>
                <div>
                  <button
                    type="button"
                    disabled={downloading}
                    onClick={() => {
                      setDlType("without");
                      const name = `${details?.apiRequestConfirmation?.roomInfo?.[0]?.paxInfo?.[0]?.firstName}_${details?.apiRequestConfirmation?.roomInfo?.[0]?.paxInfo?.[0]?.lastName}`;
                      download(
                        "/hotels/booking-details-pdf",
                        { _id: details?._id, withoutFare: true },
                        `hotel-booking-${name}-${details?.bookingReference || details?.apiResponseConfirmation?.APIRefNo || details?._id}`
                      );
                    }}
                    className="hw-btn hw-btn--primaryOutline" style={{ minWidth: "130px" }}
                  >
                    {downloading && dlType === "without" ? <BtnSpinner /> : "Without Fare"}
                  </button>
                </div>
              </div>
            </div></>
        ) : null}
        {currentTab === HotelCheckoutTabs.REVIEW ? (
          <>
            {/* <div className="hw-hotel--guestDivider" /> */}
            <div className="hw-exchk--panelTitle hw-text18 hw-hotel--reviewPayTitle">Select Payment Method</div>
            <Payment
              hideButton
              setFieldValue={setFieldValue}
              selectedMethod={values?.paymentMethod}
              error={touched?.paymentMethod && errors?.paymentMethod}
              onlinePaymentEnable={onlinePaymentEnable}
            />

            <div className="hw-exchk--field hw-exchk--bookingRef hw-hotel--payField">
              <label className="hw-exchk--label">
                Booking Reference <span className="hw-exchk--optional">(optional)</span>
              </label>
              <input
                placeholder="Enter booking reference"
                className="hw-form--input"
                onChange={(e) => setFieldValue("bookingReferenceNote", e.target.value)}
                value={values?.bookingReferenceNote || ""}
              />
            </div>

            <div className="hw-term--condition hw-hotel--payField">
              <div className="hw-term--conditionInput">
                <input
                  name="termsAccepted"
                  type="checkbox"
                  id="input-accept"
                  onChange={(e) => {
                    setAcceptTerms?.({
                      value: e.target.checked,
                      touched: true,
                    });
                  }}
                  checked={acceptTerms?.value}
                />
                <label htmlFor="input-accept">
                  By continuing you agree to our
                  <a
                    target="_blank"
                    href={`${process.env.wordpressApiEndPoint}terms-conditions`}
                    className="hw-link--line"
                  >
                    Terms & Conditions
                  </a>
                  and
                  <a
                    target="_blank"
                    href={`${process.env.wordpressApiEndPoint}privacy-policy`}
                    className="hw-link--line"
                  >
                    Privacy Policy.
                  </a>
                </label>
              </div>
              {!acceptTerms?.value && acceptTerms?.touched && (
                <p className="hw-p-error-cls">Please accept the Terms &amp; Conditions to continue.</p>
              )}
            </div>
          </>
        ) : null}
        {currentTab === HotelCheckoutTabs.GUEST_DETAILS ? (
          <div className="hw-hotel--guestFoot">
            <button
              type="button"
              className="hw-btn hw-btn--primary hw-exchk--btnWide"
              onClick={onContinue}
            >
              Continue to Payment
            </button>
          </div>
        ) : null}
      </div>

      {/* {currentTab === HotelCheckoutTabs.REVIEW ? (
        <HotelCheckoutGeneralTerms data={remarks} />
      ) : null} */}
    </div>
  );
};
